import {Component, EventEmitter, Input, Output, ViewChild} from "@angular/core";
import {ActivatedRoute} from "@angular/router";
import {Store} from "@ngrx/store";
import {
  SessionSchedulerComponent
} from "../../../../shared/components/session-scheduler/session-scheduler/session-scheduler.component";
import {
  CreateGroupRequest,
  FetchSessionListRequest,
  UpdateGroupDetailsRequest
} from "../../core/group-details.actions";
import {
  groupDetails,
  groupDetailsLoading,
  sessionList
} from "../../core/group-details.selector";
import {filter, Subject, takeUntil} from "rxjs";
import {profileData} from "../../../../shared/core/shared.selectors";
import * as moment from "moment";
import {roles} from "../../../../shared/constants/common.constants";
import {CommonService} from "../../../../shared/services/common.service";
import {GroupDetailsService} from "../../core/group-details.service";

@Component({
  selector: 'app-group-sessions-screen',
  templateUrl: './group-sessions-screen.component.html',
  styleUrls: ['./group-sessions-screen.component.css']
})
export class GroupSessionsScreenComponent {
  @ViewChild(SessionSchedulerComponent) sessionSchedulerComponent: SessionSchedulerComponent;
  @Input() groupId: string;
  @Input() groupStatus: number;
  @Input() loadedScreen: boolean;
  @Input() startDateTime = null;
  @Input() clientId = null;
  @Input() payload: any;
  @Input() editable = false;
  @Input() resetSessionsList = false;
  @Output() handlePreviousClick = new EventEmitter();
  noOfWeeks = 30;
  originalSessionsList: any;
  role: number;
  sessionId: any;
  reSchedule: any;
  saveButtonLoading: boolean = false;
  sessionList: any = [];
  private readonly onDestroy: Subject<any> = new Subject<any>();
  private groupStatusMap = {
    valid: [1, 2, 3, 4],
    notStarted: 1,
    active: 2,
    completed: 3,
    discontinued: 4
  };

  constructor(
    private route: ActivatedRoute,
    private store: Store,
    private commonService: CommonService,
    private groupDetailsService: GroupDetailsService
  ) {
    this.sessionId = this.route.snapshot.paramMap.get('sessionId');
    this.reSchedule = this.route.snapshot.queryParamMap.get('reSchedule');

    this.store.dispatch(FetchSessionListRequest());
    this.store.select(groupDetails)
      .pipe(
        filter(data => !!data.details),
      )
      .subscribe(data => {
        if (!this.sessionList.length) {
          data.details.sessions.forEach(d => {
            this.sessionList.push({
              sessionNumber: d.sessionId,
              dateTime: moment(d?.meetingOn).toISOString()
            });
          });
        }
      }).unsubscribe();

    this.store.select(sessionList)
      .pipe(takeUntil(this.onDestroy))
      .subscribe(data => {
        this.originalSessionsList = data.list;
      });

    this.store.select(profileData)
      .pipe(takeUntil(this.onDestroy))
      .subscribe(data => {
        this.role = data?.profile?.role
      })
  }

  ngOnInit() {
    this.commonService
      .onNavigationEnd
      .pipe(takeUntil(this.onDestroy))
      .subscribe(d => {
        const urlParams = {
          params: this.route.snapshot.params,
          queryParams: this.route.snapshot.queryParams
        }

        const prevUrlParams = this.commonService.urlParams.getValue();
        
        if (d.isRouteChanged || JSON.stringify(prevUrlParams) !== JSON.stringify(urlParams)) {
         this.commonService.urlParams.next(urlParams);
        }
      });

    this.groupDetailsService
      .disableForm
      .pipe(takeUntil(this.onDestroy))
      .subscribe(d => {
        this.editable = false;
      });

    this.store.select(groupDetailsLoading).pipe(takeUntil(this.onDestroy))
      .subscribe(loading => {
        this.saveButtonLoading = loading;
      })
  }

  addWeek() {
    if (!this.editable) {
      return;
    }
    this.noOfWeeks++;
    this.sessionSchedulerComponent.addWeek();
  }

  edit() {
    this.editable = true;
  }

  save() {
    const payload = {
      ...this.payload,
      sessions: this.sessionSchedulerComponent.sessionList.map((session) => {
        return {
          id: this.originalSessionsList[session.sessionNumber - 1].id,
          date: session.dateTime,
        }
      }),
    }

    const status = this.payload?.status || this.groupStatus;

    if (status === this.groupStatusMap.completed || status === this.groupStatusMap.discontinued) {
      this.commonService.openConfirmationDialog({
        data: {
          message: 'After Changing the Status to "Completed" or' +
                   ' "Discontinued", status cannot be changed back to' +
                   ' "Active" or "Not Started". \n Do You Wish to proceed?',
          submitText: 'Yes',
          classList: 'w-[40vw]',
          handleSubmit: () => {

            if (this.groupId) {
              this.store.dispatch(
                UpdateGroupDetailsRequest({
                  payload: {
                    ...(this.role === roles.superAdmin ? {clientId: this.clientId} : {}),
                    ...payload,
                    groupId: this.groupId,
                    sessionId: this.sessionId,
                    reSchedule: this.reSchedule
                  },
                }),
              );
            } else {
              this.store.dispatch(CreateGroupRequest({payload, role: this.role}));
            }
            this.commonService.closeDialog();
          },
          cancelText: 'No',
          handleCancel: () => {
            this.commonService.closeDialog();
          }
        }
      })
    }
    else{
      if (this.groupId) {
        this.store.dispatch(
          UpdateGroupDetailsRequest({
            payload: {
              ...(this.role === roles.superAdmin ? {clientId: this.clientId} : {}),
              ...payload,
              groupId: this.groupId,
              sessionId: this.sessionId,
              reSchedule: this.reSchedule
            },
          }),
        );
      } else {
        this.store.dispatch(CreateGroupRequest({payload, role: this.role}));
      }
    }
  }

  back() {
    this.handlePreviousClick.emit();
  }
}
